<template>
  <a-layout id="components-layout-demo-custom-trigger" class="home-container">

    <div style="">
      <router-view></router-view>
    </div>

  </a-layout>
</template>
<script>
export default {
  data() {
    return {
        httplogo:'',
      logoimg:logoimg,
      titlekey:1,
      current: ["mail"],
      collapsed: false,
      configdata: {},
      openKeys: [],
      value1: new Date(2016, 9, 10, 18, 40),
      value2: new Date(2016, 9, 10, 18, 40),
    };
  },
  created() {
    this.httplogo = "/imgs/" + window.location.hostname + "/logo.png"
    conf_list({}).then((response) => {
      this.configdata = response.data;
      document.title=this.configdata.projectname
    });
  },
  methods: {
    gohome(){
      window.location.replace("/");
    },
    gokefu(){
      window.open('http://service.xahuadao.com/chat/pc?token=dd58500b04dfaa2f68f2cb59da614644&noCanClose=1','_blank')
    },
    homepay() {
      window.location.replace("/");
    },
  },
};
</script>
<style lang="css" scoped>

</style>
